import { useEffect, useState } from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { Text } from '../../common/designs'
import type { Tag } from '../../common/types/common'
import { decompressAndDecodeJSON } from '../../common/utils/jsonCompression'
import BusinessAppsLeftApplicationNavBar from './BusinessAppsLeftApplicationNavBar'
import { getAppNameFromContentTags } from './utils'

const BusinessAppsLayout = () => {
  const { encodedAppTags, encodedWindowTags } = useParams()

  const [tagFilters, setTagFilters] = useState<Tag[]>([])

  useEffect(() => {
    setTagFilters(
      encodedWindowTags
        ? decompressAndDecodeJSON<Tag[]>(encodedWindowTags as string)
        : encodedAppTags
          ? decompressAndDecodeJSON<Tag[]>(encodedAppTags as string)
          : [],
    )
  }, [encodedAppTags, encodedWindowTags])

  const appName = tagFilters && getAppNameFromContentTags(tagFilters)

  return (
    <div className='flex h-[calc(100vh-228px)] gap-3'>
      <div className='w-60'>
        <Text weight={700} className='pl-3'>
          Business apps
        </Text>

        <BusinessAppsLeftApplicationNavBar />
      </div>

      <div className='-my-2 w-[calc(100vw-305px)] overflow-y-auto px-2'>
        <Outlet context={{ tagFilters, appName }} />
      </div>
    </div>
  )
}

export default BusinessAppsLayout

